import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Button,
  Box,
} from "@mui/material";
import Card, { LoaderWrapper } from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../../components/LayoutWrapper/LayoutWrapper";
import { useSelections } from "../../../context/Selections";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { KpisAreaAtuacao } from "../../../components/KPIsInsights/KPIsAreaAtuacao";
import CircleLoader from "../../../components/Loaders/CircleLoader";

function InsightsPosiDesktop({ app, config }) {
  const { selections } = useSelections();
  const [selectedValue, setselectedValue] = useState("Cuidados com a pele");
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [textQuarter, setTextQuarter] = useState();
  const [textQuarterOne, setTextQuarterOne] = useState();
  const [textQuarterTwo, setTextQuarterTwo] = useState();
  const [textQuarterThree, setTextQuarterThree] = useState();
  const [textQuarterFoor, setTextQuarterFoor] = useState();
  const [showGraph, setShowGraph] = useState(false);

  function handleChange(value) {
    app.field("Agrp").selectMatch(value);
  }

  const exportToXLS = async (objectId, isContainer) => {
    setLoadingExcel(true);
    let id = objectId;

    if (isContainer) {
      await app.visualization
        .get(objectId)
        .then((vis) => {
          id = vis.model.items.activeId;
        })
        .catch(() => setLoadingExcel(false));
    }

    if (app && id) {
      await app.visualization
        .get(id)
        .then((vis) => {
          vis.table.exportData({ format: "OOXML", state: "A" }).then((link) => {
            setLoadingExcel(false);
            const xlsLink = `https://qsense.mtrix.com.br${
              process.env.REACT_APP_PREFIX
            }${link.substring(link.indexOf("tempcontent"))}`;
            window.open(xlsLink);
          });
        })
        .catch(() => setLoadingExcel(false));
    }
  };

  const fetchKPIValueShowGraph = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setShowGraph(value > 0 ? true : false);
        });
      }
    },
    [app, setTextQuarter]
  );

  const fetchKPIValue = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          if (!position) {
            setTextQuarter(value && value[0] !== "-" ? value : null);
          } else {
            position === 1 &&
              setTextQuarterOne(value && value[0] !== "-" ? value : null);
            position === 2 &&
              setTextQuarterTwo(value && value[0] !== "-" ? value : null);
            position === 3 &&
              setTextQuarterThree(value && value[0] !== "-" ? value : null);
            position === 4 &&
              setTextQuarterFoor(value && value[0] !== "-" ? value : null);
          }
        });
      }
    },
    [app, setTextQuarter]
  );

  useEffect(() => {
    if (app) {
      const visaoField = selections.find((s) => s.qField === "Agrp");
      setselectedValue(visaoField?.qSelected);
      fetchKPIValue("jzfBCy");
      fetchKPIValue("HJmznE", 1);
      fetchKPIValue("aerRs", 2);
      fetchKPIValue("FZfyru", 3);
      fetchKPIValue("vrDEU", 4);

      fetchKPIValueShowGraph("mvhqEX");
    }
  }, [app, selections]);

  return (
    <div className="app insightstArea">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container width={"100%"}>
            <Grid className="container-line-one-insights">
              <span className="title-form"> Agrupamento estratégico </span>
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Cuidados com a Pele"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={(e) => handleChange(e.target.value)}
                  sx={{ marginLeft: "20px" }}
                >
                  <FormControlLabel
                    value="Cuidados com a Pele"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Cuidados com a pele"
                  />

                  <FormControlLabel
                    value="Esmaltes"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Esmaltes"
                  />

                  <FormControlLabel
                    value="Cuidados Pessoais"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Cuidados Pessoais"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid width={"100%"}>
              <Grid className="container-part-one-line-one-insights">
                <Grid className="container-kpis-days">
                  <Card
                    app={app}
                    header={{
                      hardTitle: `Quanto tempo falta para fechar ${textQuarter}?`,
                    }}
                  >
                    <KpisAreaAtuacao
                      app={app}
                      idNumberFrist={"cb08c9e0-8346-4fc1-9cd6-865f697169a8"}
                      idNumberSecond={"cde3b029-c9f1-4576-b6fb-2c55407b6c03"}
                      idPercentageProgress={
                        "3a490bd8-9069-4020-9791-5134c00e2877"
                      }
                      idNumberPercentage={
                        "3a490bd8-9069-4020-9791-5134c00e2877"
                      }
                      days
                    />
                  </Card>
                </Grid>

                <Grid className="container-kpis-days">
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Como estamos em relação à meta?",
                    }}
                  >
                    <KpisAreaAtuacao
                      app={app}
                      idNumberFrist={"6a3e6c5f-8fc3-4cfa-9278-2d54b42ec960"}
                      idNumberSecond={"bbec813e-ff61-44c1-8569-1e3641f6f265"}
                      idPercentageProgress={
                        "3a490bd8-9069-4020-9791-5134c00e2877"
                      }
                      idNumberPercentage={
                        "b78371f7-34be-48d3-865c-65fc927b5549"
                      }
                    />
                  </Card>
                </Grid>
              </Grid>
              {showGraph && (
                <Grid className="container-part-dois-line-two">
                  <Card
                    app={app}
                    header={{
                      hardTitle:
                        "Quantos distribuidores estão abaixo ou acima da meta?",
                    }}
                    className="container-table-line-insight"
                  >
                    <NativeObject
                      app={app}
                      key="92acebbb-440a-46aa-b04f-b8b2558e6485"
                      type={"table"}
                      reference={{
                        id: "92acebbb-440a-46aa-b04f-b8b2558e6485",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",

                        width: "100%",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle:
                        "Quais distribuidores puxam o resultado para baixo?",
                    }}
                    className="container-table-line-insight"
                  >
                    <NativeObject
                      app={app}
                      key="144b200c-cda7-40b6-ad60-6b735632cb5a"
                      type={"table"}
                      reference={{
                        id: "144b200c-cda7-40b6-ad60-6b735632cb5a",
                      }}
                      style={{
                        padding: "0",
                        height: "260px",
                        width: "100%",
                      }}
                    />
                  </Card>
                </Grid>
              )}
            </Grid>

            <Grid className="container-last-line-insights">
              {showGraph && (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Performance",
                  }}
                >
                  <ul className="container-legenda">
                    <div className="text-quadrado">legenda</div>
                    <li>
                      <span className="quadrado sell"></span>
                      <span className="text-quadrado">
                        <span className="text">Sell out de</span>
                        <NativeObject
                          app={app}
                          key="HJmznE"
                          reference={{
                            id: "HJmznE",
                          }}
                          style={{
                            padding: "0",
                            height: "30px",
                            fontSize: "14px !important",
                            width: "62px",
                          }}
                        />
                      </span>
                    </li>

                    <li>
                      <span className="quadrado media"></span>
                      <span className="text-quadrado">
                        Média nos Quarters anteriores
                      </span>
                    </li>

                    <li>
                      <span className="quadrado maxima"></span>
                      <span className="text-quadrado">
                        Máxima realizada em Quarters anteriores
                      </span>
                    </li>

                    <li>
                      <span className="quadrado meta"></span>
                      <span className="text-quadrado">
                        <span className="text">Meta de</span>
                        <NativeObject
                          app={app}
                          key="HJmznE"
                          reference={{
                            id: "HJmznE",
                          }}
                          style={{
                            padding: "0",
                            height: "30px",
                            fontSize: "14px !important",
                            width: "62px",
                          }}
                        />
                      </span>
                    </li>
                  </ul>
                  <NativeObject
                    app={app}
                    key="4f2e97bf-6b7f-477d-a6b9-e7395c95d579"
                    type={"table"}
                    reference={{
                      id: "4f2e97bf-6b7f-477d-a6b9-e7395c95d579",
                    }}
                    style={{
                      padding: "0",
                      height: "300px",
                      width: "100%",
                    }}
                  />
                </Card>
              )}

              <Card
                app={app}
                header={{
                  hardTitle: "Onde atacar e o que vender",
                }}
              >
                <Grid className="container-last-line-objects">
                  <div>
                    <div className="container-line-export-button">
                      <Grid
                        className="container-periodo"
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        xs
                      >
                        <p style={{ height: "30px" }}>
                          Não comprou em {textQuarterOne}, mas comprou em{" "}
                          {textQuarterTwo} e/ou {textQuarterThree} e/ou{" "}
                          {textQuarterFoor}
                        </p>
                      </Grid>

                      <Tooltip title="Exportar para Excel">
                        <Button
                          type="button"
                          onClick={() =>
                            exportToXLS(
                              "79600f6d-6cc3-4fe8-a76c-8d4662f1241a",
                              true
                            )
                          }
                          endIcon={<FileDownloadOutlinedIcon />}
                          className="export-button"
                        >
                          {!loadingExcel ? (
                            <Box component={"span"}>
                              Exportar Lista Completa
                            </Box>
                          ) : (
                            <LoaderWrapper>
                              <CircleLoader />
                            </LoaderWrapper>
                          )}
                        </Button>
                      </Tooltip>
                    </div>
                    <NativeObject
                      app={app}
                      key="79600f6d-6cc3-4fe8-a76c-8d4662f1241a"
                      type={"table"}
                      reference={{
                        id: "79600f6d-6cc3-4fe8-a76c-8d4662f1241a",
                      }}
                      style={{
                        padding: "0",
                        height: "360px",
                        width: "100%",
                      }}
                    />
                  </div>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

InsightsPosiDesktop.defaultProps = {
  app: null,
  config: {},
};

InsightsPosiDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default InsightsPosiDesktop;
